module.exports = __webpack_public_path__ + "img/2024-08-29b_2.bd66927f.jpg";